/*
 * <secondary-variant-select>: a compact <select> (used in the sticky bar) whose options carry
 * data-options="Value 1 / Value 2". Changing it drives the main <variant-selects> so a single
 * section-render request updates the whole page; it re-syncs itself after every variant change.
 */
class SecondaryVariantSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    if (!this.select) return;
    this.select.addEventListener('change', this.onChange.bind(this));
    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  get variantSelects() {
    const section = this.closest('.shopify-section') || document;
    return section.querySelector('variant-selects');
  }

  onChange() {
    const option = this.select.selectedOptions[0];
    if (!option) return;
    const values = (option.dataset.options || option.value).split(' / ');
    this.variantSelects?.selectByValues?.(values);
  }

  onVariantChange({ data }) {
    if (!data?.variant || !this.select) return;
    const title = data.variant.title;
    const match = Array.from(this.select.options).find(
      (option) => option.dataset.options === title || option.value === title
    );
    if (match && !match.selected) match.selected = true;
  }
}

if (!customElements.get('secondary-variant-select')) {
  customElements.define('secondary-variant-select', SecondaryVariantSelect);
}
